import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IWorkspace } from "models/IWorkspace";

interface IWorkspaceState {
  value: IWorkspace[];
  isLoading: boolean;
}

const initialState: IWorkspaceState = {
  value: [],
  isLoading: true,
};

const workspacesSlice = createSlice({
  name: "workspacesSlice",
  initialState,
  reducers: {
    setWorkspaces: (state, action: PayloadAction<IWorkspace[]>) => {
      state.value = action.payload;
      state.isLoading = false;
    },
    addWorkspace: (state, action: PayloadAction<IWorkspace>) => {
      state.value.push(action.payload);
    },
    updateWorkspaceInSlice: (state, action: PayloadAction<IWorkspace>) => {
      const index = state.value.findIndex(
        (workspace) => workspace.id === action.payload.id,
      );
      if (index !== -1) {
        state.value[index] = action.payload;
      }
    },
    removeWorkspace: (state, action: PayloadAction<string>) => {
      state.value = state.value.filter(
        (workspace) => workspace.id !== action.payload,
      );
    },
  },
});

export const {
  setWorkspaces,
  addWorkspace,
  updateWorkspaceInSlice,
  removeWorkspace,
} = workspacesSlice.actions;

const selectAllWorkspaces = (state: { workspacesSlice: IWorkspaceState }) =>
  state.workspacesSlice.value;

export const selectAvailableWorkspaces = createSelector(
  [selectAllWorkspaces],
  (workspaces) => workspaces.filter((w) => !w.archived),
);

export default workspacesSlice.reducer;
